import type { Event, EventHint } from '@sentry/vue'

/** Returning null below makes the SDK raise this internally, and something then trips over its frozen message. */
export const DROPPED_EVENT_ERROR_PATTERN = 'An event processor returned'

/**
 * A 401 only means the session expired, and the response interceptor has already resolved it —
 * sent the user to log in again, or let them carry on as a guest. It reaches Sentry only because the store action
 * that made the request has no catch, which makes it an unhandled rejection rather than a defect.
 */
export function dropExpiredSessionErrors(event: Event, hint: EventHint): Event | null {
	const error = hint?.originalException as { handled?: boolean; status?: number } | undefined

	if (error?.handled === true && error?.status === 401) {
		return null
	}

	return event
}
